import { render } from "./PasswordResetAskForm.vue?vue&type=template&id=3a478cca"
import script from "./js/passwordResetAskForm.js?vue&type=script&lang=js&external"
export * from "./js/passwordResetAskForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__